var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "website-basket-padding border-bottom" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$resourceString["Checkout.Shipping.Title"]) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "website-basket-padding border-bottom" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-start flex-row" }, [
      _c("div", { staticClass: "d-flex flex-column mr-5" }, [
        _c("p", { staticClass: "font-16 font-weight-bold mt-2" }, [
          _vm._v("Ship To:")
        ]),
        _vm._v(" "),
        _c("select", { staticClass: "font-16", attrs: { name: "address" } }, [
          _c("option", { attrs: { value: "address1" } }, [
            _vm._v("Address #1")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "address2" } }, [
            _vm._v("Address #2")
          ]),
          _vm._v(" "),
          _c("option", { attrs: { disabled: "" } }, [_vm._v("──────────")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "newaddress", disabled: "" } }, [
            _vm._v("Add new address")
          ])
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "font-16 mt-2 danger",
            attrs: { id: "editAddressBtn" }
          },
          [_vm._v("Edit Address")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal", attrs: { id: "addressModal" } }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("span", { staticClass: "close" }, [_vm._v("×")]),
            _vm._v(" "),
            _c("p", [_vm._v("Some text in the Modal..")])
          ])
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "font-16 mt-4 danger" }, [
          _vm._v("Need to ship your items to more than one address?")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column ml-5 mr-5" }, [
        _c("p", { staticClass: "font-16 font-weight-bold mt-2" }, [
          _vm._v("Sample Delivery Options:")
        ]),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "radio",
            id: "second",
            name: "ship",
            value: "second",
            checked: ""
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "font-16 font-weight-bold", attrs: { for: "second" } },
          [_vm._v("Second day")]
        ),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "radio",
            id: "standard",
            name: "ship",
            value: "standard"
          }
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "font-16 font-weight-bold",
            attrs: { for: "standard" }
          },
          [_vm._v("Standard")]
        ),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "radio", id: "ground", name: "ship", value: "ground" }
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "font-16 font-weight-bold", attrs: { for: "ground" } },
          [_vm._v("Ground")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column ml-5" }, [
        _c("p", { staticClass: "font-16 font-weight-bold mt-2" }, [
          _vm._v("Note:")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "font-16 w-50" }, [
          _vm._v(
            "\n        All Design Trays are shipped separately FedEx Overnight\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }